import Flickity from 'flickity-imagesloaded'
import 'flickity-fullscreen'

export const settings = {
  selector: '.js-single-property-space__carousel-wrapper',
  carouselSelector: '.js-single-property-space__carousel',
  thumbsSelector: '.js-single-space-image-thumbs',
  thumbSelector: '.js-single-space-image-thumb',
  mainImageSelector: '.js-single-space-image-main',
  mainImageLabelSelector: '.t-single-property__image-big__label',
  mainImageWrapSelector: '.t-single-property__image-big-wrap'
}

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(( element ) => {
    init( element )
  })
}

/**
 * Function initializes single element.
 * @param {DOMNode} element
 */
export function init( element ) {
  const thumbsEl = element.querySelector( settings.thumbsSelector )
  const mainImage = document.querySelector( settings.mainImageSelector )
  const mainImageLabel = document.querySelector( settings.mainImageLabelSelector )
  const mainImageWrap = document.querySelector( settings.mainImageWrapSelector )
  if ( thumbsEl && mainImage ) {
    initCarousel( thumbsEl, element, mainImage, mainImageLabel, mainImageWrap )
  }
}

/**
 *
 * @param {DOMNode} thumbsEl
 * @param {DOMNode} wrapper
 * @param {HTMLImageElement} mainImage
 * @param {HTMLSpanElement|null} mainImageLabel
 * @param {HTMLDivElement|null} mainImageWrap
 */
function initCarousel( thumbsEl, wrapper, mainImage, mainImageLabel, mainImageWrap ) {
  const thumbs = Array.from( thumbsEl.querySelectorAll( settings.thumbSelector ))
  if ( thumbs.length === 0 ) {
    return
  }

  const visibleThumbs = 4
  const enableThumbsLoop = thumbs.length > visibleThumbs

  const thumbsCarousel = new Flickity( thumbsEl, {
    imagesLoaded: true,
    cellSelector: settings.thumbSelector,
    pageDots: false,
    prevNextButtons: enableThumbsLoop,
    draggable: enableThumbsLoop,
    autoPlay: false,
    pauseAutoPlayOnHover: false,
    wrapAround: enableThumbsLoop,
    cellAlign: 'left',
    contain: true,
    arrowShape: {
      x0: 20,
      x1: 70, y1: 40,
      x2: 70, y2: 0,
      x3: 70
    }
  })

  const carouselEl = wrapper.querySelector( settings.carouselSelector )
  const fullCarousel = carouselEl ? new Flickity( carouselEl, {
    lazyLoad: true,
    imagesLoaded: true,
    cellSelector: '.carousel-cell',
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    autoPlay: false,
    pauseAutoPlayOnHover: false,
    wrapAround: true,
    cellAlign: 'center',
    fullscreen: true,
    contain: true,
    arrowShape: {
      x0: 20,
      x1: 70, y1: 40,
      x2: 70, y2: 0,
      x3: 70
    }
  }) : null

  let selectedIndex = 0

  /**
   * Update the main image to match a thumb selection.
   * @param {HTMLElement} thumb
   * @param {number} index
   */
  const updateMainImage = ( thumb, index ) => {
    const { fullSrc, fullSrcset, fullSizes, alt } = thumb.dataset
    if ( fullSrc ) {
      mainImage.src = fullSrc
      if ( fullSrcset ) {
        mainImage.srcset = fullSrcset
      } else {
        mainImage.removeAttribute( 'srcset' )
      }
      if ( fullSizes ) {
        mainImage.sizes = fullSizes
      } else {
        mainImage.removeAttribute( 'sizes' )
      }
    }
    if ( typeof alt === 'string' ) {
      mainImage.alt = alt
    }
    if ( mainImageLabel ) {
      const isIllustration = thumb.hasAttribute( 'data-is-illustration' )
      if ( isIllustration ) {
        mainImageLabel.classList.add( 'is-visible' )
      } else {
        mainImageLabel.classList.remove( 'is-visible' )
      }
    }
    if ( mainImageWrap ) {
      mainImageWrap.classList.toggle( 'hide-movein-logo', thumb.hasAttribute( 'data-hide-movein-logo' ))
      if ( thumb.hasAttribute( 'data-is-plan' )) {
        mainImageWrap.classList.add( 'is-plan' )
      } else {
        mainImageWrap.classList.remove( 'is-plan' )
      }
    }
    selectedIndex = index
  }

  /**
   * Sync thumb, main image, and fullscreen carousel selection.
   * @param {number} index
   * @param {Object} options
   * @param {boolean} options.syncThumbs
   * @param {boolean} options.syncFull
   */
  const syncSelection = ( index, options = {}) => {
    if ( !thumbs[ index ]) {
      return
    }
    const { syncThumbs = true, syncFull = true } = options
    updateMainImage( thumbs[ index ], index )
    if ( syncThumbs && thumbsCarousel.selectedIndex !== index ) {
      thumbsCarousel.select( index )
    }
    if ( syncFull && fullCarousel && fullCarousel.selectedIndex !== index ) {
      fullCarousel.select( index, false, true )
    }
  }

  thumbs.forEach(( thumb, index ) => {
    thumb.addEventListener( 'click', ( e ) => {
      e.preventDefault()
      syncSelection( index, { syncThumbs: true, syncFull: true })
    })
  })

  thumbsCarousel.on( 'select', () => {
    syncSelection( thumbsCarousel.selectedIndex, { syncThumbs: false, syncFull: true })
  })

  if ( fullCarousel ) {
    fullCarousel.on( 'select', () => {
      syncSelection( fullCarousel.selectedIndex, { syncThumbs: true, syncFull: false })
    })

    fullCarousel.on( 'staticClick', ( event, pointer, cellElement, cellIndex ) => {
      if ( event && pointer && cellElement && typeof cellIndex === 'number' ) {
        fullCarousel.select( cellIndex, false, true )
        fullCarousel.viewFullscreen()
      }
    })
  }

  mainImage.addEventListener( 'click', () => {
    if ( fullCarousel ) {
      fullCarousel.select( selectedIndex, false, true )
      fullCarousel.viewFullscreen()
    }
  })

  syncSelection( 0, { syncThumbs: false, syncFull: true })
}
